/**
 * Payment and terms tracking events for RBC flight checkout
 */

// Raw event names
export enum PaymentRawEventName {
  SelectTerms = "SelectTerms",
  ViewedTerms = "ViewedTerms",
}

// Amplitude event names
export enum PaymentEventName {
  select_terms = "select_terms",
  viewed_terms = "viewed_terms",
}

// Raw events
export interface SelectTermsRawEvent {
  name: PaymentRawEventName.SelectTerms;
  properties: Record<string, never>; // No additional properties needed
}

export interface ViewedTermsRawEvent {
  name: PaymentRawEventName.ViewedTerms;
  properties: {
    /** Link type: government_travel_advice, avion_terms, hts_terms, hts_privacy, avion_privacy */
    link: string;
  };
}

// Amplitude events

export interface SelectTermsEvent {
  name: PaymentEventName.select_terms;
  properties: Record<string, never>;
}

export interface ViewedTermsEvent {
  name: PaymentEventName.viewed_terms;
  properties: {
    /** Link type */
    link: string;
  };
}

// Union types
export type PaymentRawEvent = SelectTermsRawEvent | ViewedTermsRawEvent;

export type PaymentEvent = SelectTermsEvent | ViewedTermsEvent;
